import { Component, EventEmitter, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from '../../Services/ConfigService';
import { PersonRoleEnum } from '../../Models/OtherClasses';

@Component({
	selector: 'StorageShell',
	templateUrl: 'StorageShell.html',

})
export class StorageShellComponent implements OnInit {


	constructor(
		private configData: ConfigService,
		private myRouter: Router
	) {
		this.isAdmin = configData.IsUserInRole(PersonRoleEnum.ADMIN);
	}

	sizeEmitter = new EventEmitter<number>();
	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		this.sizeEmitter.next(window.innerWidth);
	}
	toggleShow() {
		this.showMenu = !this.showMenu;
		this.configData.setSavedSetting('showmenu', 'settingsshell', this.showMenu);
	}
	showMenu = true;
	isAdmin = false;
	get dividerSize(): number {
		return 958;
	}
	ngOnInit() {
		this.showMenu = window.innerWidth > this.dividerSize || this.configData.getSavedSetting('showmenu', 'settingsshell');
		this.sizeEmitter.subscribe(width => {
			this.showMenu = width > this.dividerSize || this.showMenu;
		})
	}



}
